import { ReadinessSummary } from '../../readiness/components/ReadinessSummary';
import type { JobDetail } from '../../../jobs.api';

/**
 * The readiness checklist's own summary on intake (PRD → Job intake → Gates before dispatch;
 * gitaumoses4/chukua#36) — separate from `JobIntakeMissingItems`'s broader "finish the intake
 * form" note, since this is the dispatch gate, not a clerk's data-entry checklist. The two stay
 * apart rather than merging into one note.
 */
export function JobIntakeReadiness({ job }: { job: JobDetail }) {
  const unmet = job.readiness.items.filter((item) => !item.met);

  return (
    <section className="mb-5 flex flex-col gap-2 rounded-lg border border-line p-4">
      <h2 className="text-sm font-medium text-fg">Readiness for dispatch</h2>
      <ReadinessSummary readiness={job.readiness} />
      {unmet.length > 0 && <p className="text-sm text-muted">Not yet met: {unmet.map((item) => item.label).join(', ')}</p>}
    </section>
  );
}
